import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
// import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBAbM5kZXAd9Cvd0knZNWwl_hYvt5a1zMc',
  authDomain: 'nhontrach-today.firebaseapp.com',
  projectId: 'nhontrach-today',
  storageBucket: 'nhontrach-today.firebasestorage.app',
  messagingSenderId: '225565740303',
  appId: '1:225565740303:web:9d5ce7bb689d7195b9827a',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
// export const messaging = getMessaging(app);
export const storage = getStorage(app);
auth.languageCode = "vi";

export { RecaptchaVerifier, signInWithPhoneNumber };

// Hàm lấy token
// export const requestForToken = async () => {
//   try {
//     const currentToken = await getToken(messaging, {
//       vapidKey: "BMg6H2FkZP9SuIvm2w4B2QsprEqpZqlOCi6-aiIk_WiLP1jwWL-7i1gcGCCL1w31gBD5VD2pU4k1wbOacTD-wBA" // Lấy ở Firebase console > Project Settings > Cloud Messaging
//     });
//     if (currentToken) {
//       console.log("Push token:", currentToken);
//       return currentToken;
//     } else {
//       console.warn("Không tìm thấy token, user chưa cấp quyền.");
//     }
//   } catch (err) {
//     console.error("Lỗi khi lấy token:", err);
//   }
// };

// Lắng nghe notification khi web đang mở
// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     onMessage(messaging, (payload) => {
//       resolve(payload);
//     });
//   });